import { RootState } from '../store';
import { selectIsDemoMode, selectDemoStatuses } from './demo';

export const selectStatuses = (state: RootState) => {
  const isDemoMode = selectIsDemoMode(state);
  const demoStatuses = selectDemoStatuses(state);

  if (!isDemoMode) return state.status.statuses;

  // Merge demo statuses with real statuses
  return { ...state.status.statuses, ...demoStatuses };
};

export const selectStatusByListingId = (state: RootState, id: string) => {
  const statuses = selectStatuses(state);
  return statuses[id];
};
